import { NumberCell } from '@ayocore/platform/client/components/EditableGrid';
import type { EditableGridColumn } from '@ayocore/platform/client/components/EditableGrid';
import type { WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey } from './types';

export const workOrderQtyColumn: EditableGridColumn<
  WorkOrderRow,
  WorkOrderPatch,
  WorkOrderColumnKey
> = NumberCell<WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey>({
  key: 'qty',
  title: 'Кол-во',
  width: 70,
  placeholder: '0',
  minValue: 0,
  precision: 0,
});
